import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { api } from "../../common/setupApi";

export const getPreConfig = createAsyncThunk(
  "preConfig/get",
  async (_, { getState, rejectWithValue }) => {
    return api
      .get("get-configs/")
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return rejectWithValue(err.response?.data);
      });
  },
  {
    condition: (params, { getState }) => {
      if (params?.ignoreCondition) {
        return true;
      }
      // https://redux-toolkit.js.org/api/createAsyncThunk#canceling-before-execution
      const { status } = selectPreConfig(getState());
      if (status === "fulfilled" || status === "pending") {
        // Already fetched or in progress, don't need to re-fetch
        return false;
      }
    },
  }
);

const initialState = {
  status: "idle",
  data: [],
  error: null,
};

const preConfigSlice = createSlice({
  name: "preConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPreConfig.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(getPreConfig.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.data = action.payload;
      })
      .addCase(getPreConfig.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
      .addCase("auth/logout", () => initialState);
  },
});

const _selectPreConfig = (state) => state.preConfig;

export const selectPreConfig = createSelector(
  [(state) => _selectPreConfig(state)],
  (preConfig) => {
    const data = preConfig.data;
    const status = preConfig.status;
    const error = preConfig.error;
    const isLoading = status === "pending";
    return { data, status, error, isLoading };
  }
);

export default preConfigSlice.reducer;
